import { LaboratoryHttpHeaderModel } from 'app/core/services/prothesis-api/laboratory-http-header-model';
import { NumberHelper } from 'app/shared/helpers/number-helper';
import { ReadLaboratoryViewModel } from 'app/shared/prothesis-api-view-models/read-laboratory.view-model';
import { ProgressBarStorageCardModel } from '../models/progress-bar-storage-card-model';

export class ProgressBarStorageCardModelHelper {
  public static storageUsagePercentageWarning = 90;
  public static storageUsagePercentageWarning2 = 99;

  public static build(): ProgressBarStorageCardModel {
    const progressBarStorageCard = new ProgressBarStorageCardModel();
    return progressBarStorageCard;
  }

  public static fromHttpHeaderModel(laboratoryHttpHeader: LaboratoryHttpHeaderModel): ProgressBarStorageCardModel {
    return this._createFromHttpHeaderModel(laboratoryHttpHeader);
  }

  public static fromReadLaboratoryViewModel(readLaboratoryViewModel: ReadLaboratoryViewModel): ProgressBarStorageCardModel {
    return this._createFromReadLaboratoryViewModel(readLaboratoryViewModel);
  }

  private static _createFromHttpHeaderModel(laboratoryHttpHeader: LaboratoryHttpHeaderModel): ProgressBarStorageCardModel {
    const progressBarStorageCard = this.build();

    progressBarStorageCard.storageCapacityLimit = NumberHelper.calcHumanReadableFileSize(laboratoryHttpHeader?.storageCapacityLimit);
    progressBarStorageCard.storageUsage = NumberHelper.calcHumanReadableFileSize(laboratoryHttpHeader?.storageUsage);
    progressBarStorageCard.storageUsagePercentage =
      (laboratoryHttpHeader?.storageUsage as number) > 0 && laboratoryHttpHeader?.storageCapacityLimit === 0
        ? 100
        : NumberHelper.round(NumberHelper.calcPercentage(laboratoryHttpHeader?.storageUsage, laboratoryHttpHeader?.storageCapacityLimit));

    if (progressBarStorageCard.storageUsagePercentage >= this.storageUsagePercentageWarning) {
      progressBarStorageCard.warnFlag = true;
    }
    return progressBarStorageCard;
  }

  private static _createFromReadLaboratoryViewModel(readLaboratoryViewModel: ReadLaboratoryViewModel): ProgressBarStorageCardModel {
    const progressBarStorageCard = this.build();

    progressBarStorageCard.storageCapacityLimit = NumberHelper.calcHumanReadableFileSize(readLaboratoryViewModel.storageCapacityLimit);
    progressBarStorageCard.storageUsage = NumberHelper.calcHumanReadableFileSize(readLaboratoryViewModel.storageUsage);
    progressBarStorageCard.storageUsagePercentage =
      readLaboratoryViewModel.storageUsage > 0 && readLaboratoryViewModel.storageCapacityLimit === 0
        ? 100
        : NumberHelper.round(
            NumberHelper.calcPercentage(readLaboratoryViewModel.storageUsage, readLaboratoryViewModel.storageCapacityLimit),
          );

    if (progressBarStorageCard.storageUsagePercentage >= this.storageUsagePercentageWarning) {
      progressBarStorageCard.warnFlag = true;
    }
    return progressBarStorageCard;
  }
}
